import React, { useContext, useEffect, useRef, useState } from "react";

import { Html5QrcodeScanner, Html5Qrcode } from "html5-qrcode";
import { useLocation, useNavigate } from "react-router-dom";
import { t } from "i18next";
import { ThemeContext } from "./context/ThemeContext";
import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";

const ScanQR = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const qrConfig = { fps: 10, qrbox: { width: 300, height: 300 } };
  const brConfig = { fps: 10, qrbox: { width: 300, height: 150 } };
  var html5QrCode;
  const fileRef = useRef(null);
  const [cameraList, setCameraList] = useState([]);
  const [activeCamera, setActiveCamera] = useState();
  const [check, setCheck] = useState(false);

  // useEffect(() => {
  //   if (!check) {
  //     setCheck(true);
  //   }
  //   // html5QrCode = new Html5Qrcode("reader");
  //   getCameras();
  //   // const oldRegion = document.getElementById("qr-shaded-region");
  //   // oldRegion && oldRegion.remove();
  // }, []);

  // if (check) {
  //   html5QrCode = new Html5Qrcode("reader");
  // }

  // const handleClickAdvanced = () => {
  //   const qrCodeSuccessCallback = (decodedText, decodedResult) => {
  //     console.info(decodedResult, decodedText);
  //     //  props.onResult(decodedText);
  //     // alert(`decoded:__ ${decodedText}`);
  //     if (decodedText.includes("http")) {
  //       setLoading(true);
  //       window.location.replace(decodedText);
  //     }

  //     handleStop();
  //   };
  //   html5QrCode
  //     .start({ facingMode: "environment" }, qrConfig, qrCodeSuccessCallback)
  //     .then(() => {
  //       // const oldRegion = document.getElementById("qr-shaded-region");
  //       // if (oldRegion) oldRegion.innerHTML = "";
  //     });
  // };
  // const getCameras = () => {
  //   Html5Qrcode.getCameras()
  //     .then((devices) => {
  //       /**
  //        * devices would be an array of objects of type:
  //        * { id: "id", label: "label" }
  //        */
  //       console.info(devices);
  //       if (devices && devices.length) {
  //         setCameraList(devices);
  //         setActiveCamera(devices[0]);
  //       }
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //       setCameraList([]);
  //     });
  // };

  // const handleStop = () => {
  //   try {
  //     html5QrCode
  //       .stop()
  //       .then((res) => {
  //         html5QrCode.clear();
  //       })
  //       .catch((err) => {
  //       });
  //   } catch (err) {
  //   }
  // };

  const [data, setData] = useState("No result");
  const [scannerData, setScannerData] = useState("");
  const [openCamera, setOpenCamera] = useState(false);
  const [loading, setLoading] = useState(false);

  // const new_design = localStorage.getItem("new_design");
  // const theme = new_design == "true";
  const { theme } = useContext(ThemeContext);

  return (
    <div className={theme ? "food" : ""}>
      <div className="qr-code-expired">
        <div className="qr-expired-card">
          <img src="../QRCodeExpired.png" alt="" style={{ width: "400px" }} />
          <div
            style={{ gap: ".5rem", display: "flex", flexDirection: "column" }}
          >
            <h1>{t("QR Code Expired")}</h1>
            <p>
              {t("No worries, just scan the QR code in your room again to continue.")}
            </p>
          </div>
          {!loading && (
            <Button
              onClick={() => navigate(`/${room_uuid}/scan-qr-code`)}
              className="w-full"
            >
              {t("Open Camera")}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ScanQR;
